// Client-side "saved opportunities" store.
// Sprint 28b — mirrors to /api/user/saved/* when a `fursa_session` cookie
// is present (fire-and-forget; localStorage remains the fallback for
// anonymous visitors and instant UI response).

import * as authApi from "@/services/authService";

const KEY = "fursa.savedOpportunities.v1";
const hasSession = () =>
  typeof document !== "undefined" &&
  document.cookie.split(";").some((c) => c.trim().startsWith("fursa_session="));

const read = () => {
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
};

const write = (list) => {
  try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* quota */ }
};

export const isSaved = (id) => read().includes(id);
export const getSavedIds = () => read();

export const toggleSaved = (id) => {
  const list = read();
  const idx = list.indexOf(id);
  const nowSaved = idx === -1;
  if (nowSaved) list.push(id); else list.splice(idx, 1);
  write(list);
  // Mirror to the server for authenticated users. Fire-and-forget — if it
  // fails, localStorage remains the source of truth locally, and
  // /saved page's backfill reconciles on next authenticated visit.
  if (hasSession()) {
    (nowSaved ? authApi.addSaved(id) : authApi.removeSaved(id)).catch(() => {});
  }
  return nowSaved;
};
